export default __webpack_public_path__ + "static/media/swiggy.7fa2b271.png";